<template>
  <div class="introduction-container">
    <div class="breadcrumbs mb-40">
      <breadcrumb
        path="/documentation/introduction"
        name="Overview"
        :route-name="route.name"
        :is-tool="true"
      />
    </div>
    <div class="title">
      {{ title }}
    </div>
    <div class="submenu-container">
      <div class="mb-40">
        Use this call to {{ subTitle }}.
      </div>
      <div class="mb-14">
        <div class="font-w-semi-bold font-18">
          Common Parameters
        </div>
        <common-table
          :data-table-common-url="dataTableCommonUrl"
          :data-table-common-name="dataTableCommonName"
        />
      </div>
      <div class="mb-14">
        <div class="font-w-semi-bold font-18">
          Request Parameters
        </div>
        <request-table :data-table-request="dataTableRequest" />
      </div>
      <div class="mt-40 mb-24 font-w-semi-bold">
        <div class="font-w-semi-bold font-18">
          Request Example
        </div>
        <code-editor
          :data="dataRequest"
          :title="titleRequest"
          style="width: 1000px"
          @copyToClipboard="copyToClipboard"
        />
      </div>
      <div class="mb-64 font-w-semi-bold">
        <div class="font-w-semi-bold font-18">
          Response Example
        </div>
        <code-editor
          :data="dataResponse"
          title="JSON"
          style="max-width: 1000px"
          @copyToClipboard="copyToClipboard"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { dataCollection } from '@/api/endpoints/collection'
import { onMounted, computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'
import CommonTable from '../components/_commonTable.vue'
import RequestTable from '../components/_requestTable.vue'
import CodeEditor from '../components/_codeEditor.vue'
import useRequest from './useRequest.js'

const route = useRoute()
const dataRequest = ref(null)
const titleRequest = ref(null)
const dataResponse = ref(null)
const dataTableCommonUrl = ref([])
const dataTableCommonName = ref([])
const url = ref(process.env.VUE_APP_BASE_API_URL)
const title = computed(() => route.name)
const subTitle = computed(() => route.name.toLowerCase())

onMounted(() => {
  getDataCommon()
  getRequestCode()
  getResponseCode()
})

const { dataSelected, dataTableRequest } = useRequest(dataCollection, route.name, true)
const getDataCommon = () => {
  const baseUrl = url.value.replace(/\/$/, '')
  const rawUrl = dataSelected.value.request?.url?.raw
  const formattedUrl = rawUrl.replace('{{url}}', baseUrl).split('?')[0]

  dataTableCommonUrl.value.push({
    name: 'URL',
    url: formattedUrl
  })
  dataTableCommonName.value.push({
    name: 'Method',
    method: dataSelected.value.request.method
  })
}
const getRequestCode = () => {
  if (dataSelected.value.request) {
    titleRequest.value = 'JSON'
    dataRequest.value = jsonPretty(dataSelected.value.request)
  }
}
const getResponseCode = () => {
  if (dataSelected.value.response) {
    if (dataSelected.value.response[0]) {
      dataResponse.value = jsonPretty(dataSelected.value.response[0])
    }
  }
}
const jsonPretty = (json) => {
  return JSON.stringify(json, null, 4)
}
const copyToClipboard = (data) => {
  navigator.clipboard.writeText(data)
}
</script>
